import React from 'react';

const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20ZM10,.8A9.2,9.2,0,1,0,19.2,10,9.21,9.21,0,0,0,10,.8Z" />
    <path d="M11.33,10l3.52-3.52a1,1,0,0,0,0-1.33,1,1,0,0,0-1.33,0L10,8.67,6.48,5.15A.94.94,0,0,0,5.15,6.48L8.67,10,5.15,13.52a1,1,0,0,0,0,1.33,1,1,0,0,0,1.33,0L10,11.33l3.52,3.52a.94.94,0,0,0,1.33-1.33Z" />
  </svg>
);

export default ErrorIcon;
